import { render } from "./PerformanceMetricsChart.vue?vue&type=template&id=d50cea86&ts=true"
import script from "./PerformanceMetricsChart.vue?vue&type=script&lang=ts"
export * from "./PerformanceMetricsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__